// extracted by mini-css-extract-plugin
export default {"calendar_container":"MainCalendar_calendar_container__vJhqL"};